"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class IgnoreAndBlockFilterService {
    constructor(preferencesStorageService) {
        this.preferencesStorageService = preferencesStorageService;
    }
    filterBlocked(transactions) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferencesIgnoreAndBlock = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            transactions = IgnoreAndBlockFilterService.filterBlockedTransactions(transactions, preferencesIgnoreAndBlock.blockedTransactionHashes);
            if (preferencesIgnoreAndBlock.isBlockWhiteListEnabled) {
                return IgnoreAndBlockFilterService.filterWhiteList(transactions, preferencesIgnoreAndBlock.blockWhiteList);
            }
            if (preferencesIgnoreAndBlock.isBlockBlackListEnabled) {
                return IgnoreAndBlockFilterService.filterBlackList(transactions, preferencesIgnoreAndBlock.blockBlackList);
            }
            return transactions;
        });
    }
    filterIgnored(transactions) {
        return __awaiter(this, void 0, void 0, function* () {
            const preferencesIgnoreAndBlock = yield this.preferencesStorageService.getPreferencesIgnoreAndBlock();
            if (preferencesIgnoreAndBlock.isIgnoreWhiteListEnabled) {
                return IgnoreAndBlockFilterService.filterWhiteList(transactions, preferencesIgnoreAndBlock.ignoreWhiteList);
            }
            if (preferencesIgnoreAndBlock.isIgnoreBlackListEnabled) {
                return IgnoreAndBlockFilterService.filterBlackList(transactions, preferencesIgnoreAndBlock.ignoreBlackList);
            }
            return transactions;
        });
    }
    static getPublicKeysFromUsers(users) {
        return users.map((user) => {
            return user.publicKey;
        });
    }
    static filterBlackList(transactions, blackList) {
        const blackListPublicKeys = IgnoreAndBlockFilterService.getPublicKeysFromUsers(blackList);
        // Remove transactions
        transactions = transactions.filter((tx) => {
            // If not in list
            return blackListPublicKeys.indexOf(tx.creator.publicKey) === -1;
        });
        // Remove signatures
        transactions = transactions.map((tx) => {
            tx.signatures = tx.signatures.filter((signature) => {
                // If not in list
                return blackListPublicKeys.indexOf(signature.publicKey) === -1;
            });
            return tx;
        });
        return transactions;
    }
    static filterWhiteList(transactions, whiteList) {
        const whiteListPublicKeys = IgnoreAndBlockFilterService.getPublicKeysFromUsers(whiteList);
        // Remove transactions
        transactions = transactions.filter((tx) => {
            // If exists in list
            return whiteListPublicKeys.indexOf(tx.creator.publicKey) > -1;
        });
        // Remove signatures
        transactions = transactions.map((tx) => {
            tx.signatures = tx.signatures.filter((signature) => {
                // If exists in list
                return whiteListPublicKeys.indexOf(signature.publicKey) > -1;
            });
            return tx;
        });
        return transactions;
    }
    static filterBlockedTransactions(transactions, blockedHashes) {
        return transactions.filter((tx) => {
            // If not in list
            return blockedHashes.indexOf(tx.hash) === -1;
        });
    }
}
exports.IgnoreAndBlockFilterService = IgnoreAndBlockFilterService;
